/**
 * Live Sessions list (Meet + LiveKit via streaming engine selector at create).
 */
import { useEffect } from 'react';
import ViewSessions from '../../LMS/TR/files/ViewSessions';
import { clearCreateFlowExit } from '../create/utils/createSessionFlowStorage';

export default function ViewLiveKitSessions() {
  useEffect(() => {
    clearCreateFlowExit();
  }, []);

  return <ViewSessions />;
}
